import React from 'react';
import { styled } from 'dripsy';

import { BaseText } from './BaseText';
import { Touchable, ITouchableProps } from './Touchable';
import { ColorType } from '@types';

interface IActivePropsStyle {
  isActive: boolean;
  disabled: boolean;
}

function backgroundColor(props: IActivePropsStyle): ColorType {
  if (props.disabled) {
    if (props.isActive) {
      return '$primary100';
    } else {
      return '$background0';
    }
  } else {
    if (props.isActive) {
      return '$primary300';
    } else {
      return '$background0';
    }
  }
}

function textColor(props: IActivePropsStyle): ColorType {
  if (props.disabled) {
    if (props.isActive) {
      return '$text400';
    } else {
      return '$text80';
    }
  } else {
    if (props.isActive) {
      return '$heading800';
    } else {
      return '$text400';
    }
  }
}

function borderColor(props: IActivePropsStyle): ColorType {
  if (props.disabled) {
    if (props.isActive) {
      return '$primary100';
    } else {
      return '$text80';
    }
  } else {
    if (props.isActive) {
      return '$primary300';
    } else {
      return '$text400';
    }
  }
}

const TouchableContainer = styled(Touchable)(
  (props: IActivePropsStyle) => ({
    px: '$5',
    py: '$4',
    bg: backgroundColor(props),
    borderWidth: 1,
    borderColor: borderColor(props),
    borderRadius: 12,
  }),
);

const Text = styled(BaseText)((props: IActivePropsStyle) => ({
  color: textColor(props),
}));

export interface IBadgeProps extends ITouchableProps {
  isActive?: boolean;
  disabled?: boolean;
}

export function Badge({
  children,
  isActive = false,
  disabled = false,
  ...props
}: IBadgeProps) {
  return (
    <TouchableContainer
      isActive={isActive}
      disabled={disabled}
      {...props}
    >
      <Text isActive={isActive} disabled={disabled}>
        {children}
      </Text>
    </TouchableContainer>
  );
}
